module.exports = __webpack_public_path__ + "assets/img/11_764.312edd16.jpg";